export default __webpack_public_path__ + "media/images/iui/redButton-c935ba4485ba4c76a82f6bb8dd3ce764.png";